export default __webpack_public_path__ + "static/media/Path3420.154f00d5.svg";